/*
# -----------------------------------------------------------------------------
# Component: riAjaxMixin.js
# Author: ssy@pst.sg
# Created Date: 11/June/2019
# Comments: Responsible for all backend related calls for RI Header
# -----------------------------------------------------------------------------
*/
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
import { parseISO } from 'date-fns'
import { formatPrice } from '@/utils/index'
import { removeTime, formatServerTimeFormat } from '@/utils/date'
import clone from 'clone'

export const riAjaxMixin = {
  data() {
    return {
      actionType: undefined,
      polRisk: {
        premDue: undefined,
        si: undefined
      },
      riOutMaster: {
        comm1Pct: undefined,
        comm2Pct: undefined,
        comm3Pct: undefined
      },
      labels: {
        ttyNo: 'Treaty No.',
        ttyDesc: 'Treaty Description',
        inter: 'Intermediary',
        name: 'Name',
        acctNoSfx: 'Account No. Suffix'
      },
      filters: {
        ttyNo: undefined,
        ttyDesc: undefined,
        inter: undefined,
        name: undefined,
        acctNoSfx: undefined
      },
      checkCoInsQSData: {
        coInsExist: false,
        coInsPct: 0,
        notWriSIPct: 0,
        comm2Gn: undefined,
        comm3Gn: undefined,
        riPct: 0,
        disc: 0
      }
    }
  },
  computed: {
    riOutListing() {
      return this.$store.state.reinsurance.riOutListing.menu
    }
  },
  methods: {
    async performAction() {
      var success = false
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.performAction
      if (apiURI) {
        try {
          let massageRiForm = clone(this.riForm)
          if (this.polMaster) {
            massageRiForm.redBal1 = this.polMaster.redBal1
            massageRiForm.redBal1 = this.polMaster.redBal2
            massageRiForm.redBal3 = this.polMaster.redBal3
            massageRiForm.tranDate = this.polMaster.tranDate
          }
          let result = await this.$http.post(apiURI, massageRiForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          success = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        if (this.newRiHeader === true) {
          this.doFetch()
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      return success
    },
    async riDetailSave() {
      let success = false
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.riDetailSave
      if (apiURI) {
        try {
          this.riDetailForm.riSI = removeFormatNumber(this.riDetailForm.riSI)
          this.riDetailForm.riSIPct = removeFormatNumber(this.riDetailForm.riSIPct)
          this.riDetailForm.riPrem = removeFormatNumber(this.riDetailForm.riPrem)
          this.riDetailForm.prtyLim = removeFormatNumber(this.riDetailForm.prtyLim)
          this.riDetailForm.riComm1 = removeFormatNumber(this.riDetailForm.riComm1)
          this.riDetailForm.riComm2 = removeFormatNumber(this.riDetailForm.riComm2)
          this.riDetailForm.riComm3 = removeFormatNumber(this.riDetailForm.riComm3)
          this.riDetailForm.riLevy = removeFormatNumber(this.riDetailForm.riLevy)
          this.riDetailForm.riTax = removeFormatNumber(this.riDetailForm.riTax)
          const result = await this.$http.post(apiURI, this.riDetailForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doReview(this.riDetailForm)
          }
          success = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          success = false
        }
      }
      return success
    },
    parseISO(value) {
      return parseISO(value)
    },
    async doReleaseRi() {
      var success = false
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.releaseRi
      if (apiUrl) {
        try {
          const requestForm = {
            polNo: this.selectedRi.polNo
          }
          const result = await this.$http.post(apiUrl, requestForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          if (data.resultMap.checkBordereau === 'false') {
            success = false
          } else {
            success = true
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('Missing API url (Release RI)')
      }
      return success
    },
    async doFetch() {
      this.polTranRel = false
      this.riTranRel = false
      if (this.selectedRi.polNo !== undefined && this.selectedRi.renCnt !== undefined && this.selectedRi.endtCnt !== undefined) {
        const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiHeaderLists
        if (apiUrl) {
          try {
            this.loading = true
            const { page, itemsPerPage } = this.paginationRI
            const expand = {
              page: page - 1,
              size: itemsPerPage,
              polNo: this.selectedRi.polNo,
              renCnt: this.selectedRi.renCnt,
              endtCnt: this.selectedRi.endtCnt
            }
            const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.paginationRI.sortBy, this.paginationRI.sortDesc))
            if (result.data) {
              this.totalItemsRI = result.data.totalElements
              this.polTranRel = result.data.polTranRel
              this.prevRel = result.data.prevRel
              // this.riTranRel = result.data.riTranRel
              const { data } = result.data
              this.riHeaderItems = []
              if (data) {
                let riEndtCnt = data.map(a => a.endtCnt)
                data.map((riOut, i) => {
                  const convertRiOutHeader = {
                    polNo: this.selectedRi.polNo,
                    riType: riOut.riType,
                    riCo: riOut.riCo,
                    riCoDesc: riOut.riType === 'D' ? 'STAT' : riOut.riCoDesc,
                    acctNoSfx: riOut.acctNoSfx,
                    acctNoSfxDesc: riOut.acctNoSfxDesc,
                    acctNoSfxWithDesc: riOut.acctNoSfx === '' ? '' : riOut.acctNoSfx + ' - ' + riOut.acctNoSfxDesc,
                    renCnt: this.selectedRi.renCnt,
                    endtCnt: riEndtCnt[i],
                    cesEndtCnt: riOut.cesEndtCnt,
                    propXl: riOut.propXL,
                    propXlDesc: riOut.propXLDesc,
                    tranDate: riOut.tranDate,
                    tranDateDisp: this.formatDate(riOut.tranDate),
                    comDate: riOut.riComDate,
                    comDateDisp: this.formatDate(riOut.riComDate),
                    expDate: riOut.riExpDate,
                    expDateDisp: this.formatDate(riOut.riExpDate),
                    riComm2Gn: riOut.riComm2Gn,
                    riComm3Gn: riOut.riComm3Gn,
                    ccaDate: this.formatDate(riOut.ccaDate),
                    ccdDate: this.formatDate(riOut.ccdDate),
                    tranRel: riOut.tranRel,
                    cesYr: riOut.cesYr
                  }
                  this.riHeaderItems.push(convertRiOutHeader)
                })
              } else {
                this.riForm.tranDate = this.selectedRi.tranDate
                this.riForm.riComDate = this.selectedRi.comDate
                this.riForm.riExpDate = this.selectedRi.expDate
              }
              this.riForm.polNo = this.selectedRi.polNo
              this.riForm.renCnt = this.selectedRi.renCnt
              this.riForm.endtCnt = this.selectedRi.endtCnt
              // this.riForm.tranDate = this.selectedRi.tranDate
              this.riForm.riComDate = this.selectedRi.comDate
              this.riForm.riExpDate = this.selectedRi.expDate
              if (this.riForm.tranDate === undefined) {
                this.riForm.tranDate = new Date()
              }

              if (this.riForm.riComDate === undefined) {
                this.riForm.riComDate = new Date()
              }

              if (this.riForm.riExpDate === undefined) {
                this.riForm.riExpDate = new Date()
              }
            } else {
              this.riHeaderItems = []
            }
            this.firstRiHeaderReload = false
            this.loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
            this.loading = false
          }
        }
      }
    },
    async doFetchRIHeaders() {
      this.firstRiReload = false
      this.polTranRel = false
      this.riTranRel = false
      if (this.selectedRi.polNo !== undefined && this.selectedRi.renCnt !== undefined && this.selectedRi.endtCnt !== undefined) {
        const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiHeaders
        if (apiUrl) {
          try {
            this.loading = true
            const { page, itemsPerPage } = this.paginationRIHeaders
            const expand = {
              page: page - 1,
              size: itemsPerPage,
              polNo: this.selectedRi.polNo,
              renCnt: this.selectedRi.renCnt,
              endtCnt: this.selectedRi.endtCnt
            }
            const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.paginationRIHeaders.sortBy, this.paginationRIHeaders.sortDesc))
            if (result.data) {
              this.totalItemsRI = result.data.totalElements
              this.polTranRel = result.data.polTranRel
              // this.riTranRel = result.data.riTranRel
              const { data } = result.data
              this.riHeaderItems = []
              if (data) {
                data.map(riOut => {
                  const convertRiOutHeader = {
                    polNo: this.selectedRi.polNo,
                    riType: riOut.riType,
                    riCo: riOut.riCo,
                    riCoDesc: riOut.riType === 'D' ? 'STAT' : riOut.riCoDesc,
                    acctNoSfx: riOut.acctNoSfx,
                    acctNoSfxDesc: riOut.acctNoSfxDesc,
                    acctNoSfxWithDesc: riOut.acctNoSfx === '' ? '' : riOut.acctNoSfx + ' - ' + riOut.acctNoSfxDesc,
                    renCnt: this.selectedRi.renCnt,
                    endtCnt: this.selectedRi.endtCnt,
                    cesEndtCnt: riOut.cesEndtCnt,
                    propXl: riOut.propXL,
                    propXlDesc: riOut.propXLDesc,
                    tranDate: riOut.tranDate,
                    tranDateDisp: this.formatDate(riOut.tranDate),
                    comDate: riOut.riComDate,
                    comDateDisp: this.formatDate(riOut.riComDate),
                    expDate: riOut.riExpDate,
                    expDateDisp: this.formatDate(riOut.riExpDate),
                    riComm2Gn: riOut.riComm2Gn,
                    riComm3Gn: riOut.riComm3Gn,
                    ccaDate: this.formatDate(riOut.ccaDate),
                    ccdDate: this.formatDate(riOut.ccdDate),
                    tranRel: riOut.tranRel
                  }
                  this.riHeaderItems.push(convertRiOutHeader)
                })
              } else {
                this.riForm.tranDate = this.selectedRi.tranDate
                this.riForm.riComDate = this.selectedRi.comDate
                this.riForm.riExpDate = this.selectedRi.expDate
              }
              this.riForm.polNo = this.selectedRi.polNo
              this.riForm.renCnt = this.selectedRi.renCnt
              this.riForm.endtCnt = this.selectedRi.endtCnt
              this.riForm.tranDate = this.selectedRi.tranDate
              this.riForm.riComDate = this.selectedRi.comDate
              this.riForm.riExpDate = this.selectedRi.expDate
              if (this.riForm.tranDate === undefined) {
                this.riForm.tranDate = new Date()
              }
              if (this.riForm.riComDate === undefined) {
                this.riForm.riComDate = new Date()
              }
              if (this.riForm.riExpDate === undefined) {
                this.riForm.riExpDate = new Date()
              }
              if (this.riForm.tranDate !== undefined) {
                this.riForm.cesYr = removeTime(this.riForm.tranDate).getFullYear()
              }
            } else {
              this.riHeaderItems = []
            }
            this.loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
            this.loading = false
          }
        }
      }
    },
    async doFetchRiHeader(riData) {
      if (this.newRiHeader === false) {
        const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiHeaderDetail
        const requestParams = {
          polNo: riData.polNo,
          renCnt: riData.renCnt,
          cesEndtCnt: riData.cesEndtCnt,
          riType: riData.riType,
          riCo: riData.riCo,
          acctNoSfx: riData.acctNoSfx,
          endtCnt: riData.endtCnt
        }
        if (apiUrl) {
          this.loading = true
          try {
            const result = await this.$http.get(expandURI(apiUrl, requestParams))
            const { data } = result.data
            if (data && data.riHeaderDetail) {
              this.riForm.cesEndtCnt = data.riHeaderDetail.cesEndtCnt
              this.riForm.riType = data.riHeaderDetail.riType
              this.riTypeList.map(riType => {
                if (riType.value === riData.riType) {
                  this.riDetailInfo.riTypeDesc = riType.label
                }
              })
              this.riForm.riCo = data.riHeaderDetail.riCo
              this.riForm.riCoDesc = data.inter
              this.riForm.riCoWithDesc = this.riForm.riCoDesc === '' ? this.riForm.riCo : this.riForm.riCo + ' - ' + this.riForm.riCoDesc
              this.riForm.propXl = data.riHeaderDetail.propXl
              this.riForm.acctNoSfx = data.riHeaderDetail.acctNoSfx
              this.riForm.acctNoSfxDesc = data.acctNoSfxDesc
              this.riForm.acctNoSfxWithDesc = data.riHeaderDetail.acctNoSfx === undefined ? '' : data.riHeaderDetail.acctNoSfx + ' - ' + data.acctNoSfxDesc
              this.riForm.theirPolNo = data.riHeaderDetail.theirPolNo
              this.riForm.cesNo = data.riHeaderDetail.cesNo
              this.riForm.cesYr = data.riHeaderDetail.cesYr
              this.riForm.bordEreAux = data.riHeaderDetail.bordEreAux
              this.riForm.prtRiApp = data.riHeaderDetail.prtRiApp
              this.riForm.relRi = data.riHeaderDetail.relRi
              this.riForm.tranDate = data.riHeaderDetail.tranDate
              this.riForm.riComDate = data.riHeaderDetail.riComDate
              this.riForm.riExpDate = data.riHeaderDetail.riExpDate
              this.riForm.comm1AE = data.riHeaderDetail.comm1AE
              this.riForm.comm1Pct = formatDisplayNumber(data.riHeaderDetail.comm1Pct, 6)
              this.riForm.comm2AE = data.riHeaderDetail.comm2AE
              this.riForm.comm2Pct = formatDisplayNumber(data.riHeaderDetail.comm2Pct, 6)
              this.riForm.comm2Gn = data.riHeaderDetail.comm2Gn
              this.riForm.comm3AE = data.riHeaderDetail.comm3AE
              this.riForm.comm3Pct = formatDisplayNumber(data.riHeaderDetail.comm3Pct, 6)
              this.riForm.comm3Gn = data.riHeaderDetail.comm3Gn
              this.riForm.stampDuty = formatDisplayNumber(data.riHeaderDetail.stampDuty, 3)
              this.riForm.riTax = formatDisplayNumber(data.riHeaderDetail.riTax, 3)
              this.riForm.riLevy = formatDisplayNumber(data.riHeaderDetail.riLevy, 3)
              this.riForm.riAppTxt = data.riHeaderDetail.riAppTxt
              this.riForm.riAppEndtTxt = data.riHeaderDetail.riAppEndtTxt
              this.riForm.ccaDate = data.riHeaderDetail.ccaDate
              this.riForm.ccdDate = data.riHeaderDetail.ccdDate
              this.riForm.ccDateEntUsr = data.riHeaderDetail.ccDateEntUsr
              this.riForm.ccDateRevUsr = data.riHeaderDetail.ccDateRevUsr
              // LYT 2020-12-22 OS-618
              this.riForm.cesEndtNo = data.riHeaderDetail.cesEndtNo
              this.riForm.cesStamp = formatPrice(data.riHeaderDetail.cesStamp)
              this.riForm.riEndtDate = data.riHeaderDetail.riEndtDate
              this.riForm.docNo = (data.riHeaderDetail.tranType1 !== undefined ? data.riHeaderDetail.tranType1 : '') +
                (data.riHeaderDetail.docNo !== undefined ? data.riHeaderDetail.docNo : '')
              this.riForm.billCurr = data.riHeaderDetail.billCurr
              // 2021-05-21 OS-792
              this.riForm.relDate = data.riHeaderDetail.relDate
              this.riForm.relUsr = data.riHeaderDetail.relUsr !== '0' ? data.riHeaderDetail.relUsr : ''
            }
            this.loading = false
          } catch (err) {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          }
        }
      }
    },
    async doFetchPrevCesRiHeader(riData) {
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getPrevCesRiHeader
      const requestParams = {
        polNo: riData.polNo,
        renCnt: riData.renCnt,
        cesEndtCnt: riData.cesEndtCnt,
        riType: riData.riType,
        riCo: riData.riCo,
        acctNoSfx: riData.acctNoSfx
      }
      if (apiUrl) {
        this.loading = true
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data && data.prevCesRiHeader) {
            this.riPrevCesForm.polNo = data.prevCesRiHeader.polNo
            this.riPrevCesForm.renCnt = data.prevCesRiHeader.renCnt
            this.riPrevCesForm.cesEndtCnt = data.prevCesRiHeader.cesEndtCnt
            this.riPrevCesForm.riType = data.prevCesRiHeader.riType
            this.riPrevCesForm.riCo = data.prevCesRiHeader.riCo
            this.riPrevCesForm.riEndtDate = data.prevCesRiHeader.riEndtDate
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
    },
    async doFetchRiDetail(riDetail) {
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiDetailDetail
      const requestParams = {
        polNo: riDetail.polNo,
        renCnt: riDetail.renCnt,
        cesEndtCnt: riDetail.cesEndtCnt,
        riType: riDetail.riType,
        riCo: riDetail.riCo,
        acctNoSfx: riDetail.acctNoSfx,
        riskGrpNo: riDetail.riskGrpNo,
        riskNo: riDetail.riskNo,
        endtCnt: riDetail.endtCnt
      }
      if (apiUrl) {
        this.loading = true
        try {
          await this.$http.get(expandURI(apiUrl, requestParams)).then(result1 => {
            if (result1) {
              const { data } = result1.data
              this.riDetailForm.riComm1Pct = riDetail.riComm1Pct
              this.riDetailForm.riComm2Pct = riDetail.riComm2Pct
              this.riDetailForm.riComm3Pct = riDetail.riComm3Pct
              if (data && data.riDetailDetail) {
                this.riDetailForm.polNo = data.riDetailDetail.polNo
                this.riDetailForm.renCnt = data.riDetailDetail.renCnt
                this.riDetailForm.cesEndtCnt = data.riDetailDetail.cesEndtCnt
                this.riDetailForm.riType = data.riDetailDetail.riType
                this.riDetailForm.riCo = data.riDetailDetail.riCo
                this.riDetailForm.acctNoSfx = data.riDetailDetail.acctNoSfx
                this.riDetailForm.riskGrpNo = data.riDetailDetail.riskGrpNo
                this.riDetailForm.riskNo = data.riDetailDetail.riskNo
                this.riDetailForm.endtCnt = data.riDetailDetail.endtCnt
                this.riDetailForm.riskDesc = (data.riDetailDetail.riskGrpNo + ' / ' + data.riDetailDetail.riskNo)
                this.riDetailForm.riSI = formatDisplayNumber(data.riDetailDetail.riSI, 2)
                this.riDetailForm.riSIDisp = formatDisplayNumber(data.riDetailDetail.riSI, 2)
                this.riDetailForm.riSIAE = data.riDetailDetail.riSIAE
                this.riDetailForm.riSIPct = formatDisplayNumber(data.riDetailDetail.riSIPct, 6)
                this.riDetailForm.riSIPctAE = data.riDetailDetail.riSIPctAE
                this.riDetailForm.riPrem = formatDisplayNumber(data.riDetailDetail.riPrem, 2)
                this.riDetailForm.riPremDisp = formatDisplayNumber(data.riDetailDetail.riPrem, 2)
                this.riDetailForm.riPremAE = data.riDetailDetail.riPremAE
                this.riDetailForm.prtyLim = formatDisplayNumber(data.riDetailDetail.prtyLim, 2)
                this.riDetailForm.riComm1AE = data.riDetailDetail.riComm1AE
                this.riDetailForm.riComm1 = formatDisplayNumber(data.riDetailDetail.riComm1, 2)
                this.riDetailForm.riComm1Disp = formatDisplayNumber(data.riDetailDetail.riComm1, 2)
                this.riDetailForm.riComm2AE = data.riDetailDetail.riComm2AE
                this.riDetailForm.riComm2 = formatDisplayNumber(data.riDetailDetail.riComm2, 2)
                this.riDetailForm.riComm2Disp = formatDisplayNumber(data.riDetailDetail.riComm2, 2)
                this.riDetailForm.riComm3AE = data.riDetailDetail.riComm3AE
                this.riDetailForm.riComm3 = formatDisplayNumber(data.riDetailDetail.riComm3, 2)
                this.riDetailForm.riComm3Disp = formatDisplayNumber(data.riDetailDetail.riComm3, 2)
                this.riDetailForm.riTax = formatDisplayNumber(data.riDetailDetail.riTax, 2)
                this.riDetailForm.riTaxDisp = formatDisplayNumber(data.riDetailDetail.riTax, 2)
                this.riDetailForm.riTaxAE = data.riDetailDetail.riTaxAE
                this.riDetailForm.riLevy = formatDisplayNumber(data.riDetailDetail.riLevy, 2)
                this.riDetailForm.riLevyDisp = formatDisplayNumber(data.riDetailDetail.riLevy, 2)
                this.riDetailForm.riLevyAE = data.riDetailDetail.riLevyAE
                this.riDetailForm.riPremAccum = formatDisplayNumber(data.riDetailDetail.riPremAccum, 2)
                this.riDetailForm.riSIPctAccum = data.riDetailDetail.riSIPctAccum
              }
              if (data && data.polRisk) {
                this.polRisk.premDueDiscLdg = data.polRisk.premDueDiscLdg
                this.polRisk.si = data.polRisk.si
              }
              this.riOutMaster.comm1Pct = this.riForm.comm1Pct
              this.riOutMaster.comm2Pct = this.riForm.comm2Pct
              this.riOutMaster.comm3Pct = this.riForm.comm3Pct
            }
          })
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
        this.loading = false
        return true
      }
    },
    async doReview(riData) {
      this.riDetailInfo.riType = riData.riType
      this.riTypeList.map(riType => {
        if (riType.value === riData.riType) {
          this.riDetailInfo.riTypeDesc = riType.label
        }
      })
      this.riDetailInfo.riCo = riData.riCo
      this.riDetailInfo.riCoDesc = riData.riCoDesc
      this.riDetailInfo.acctNoSfx = riData.acctNoSfx
      this.riDetailInfo.acctNoSfxDesc = riData.acctNoSfxDesc
      this.riDetailInfo.propXl = riData.propXl
      this.riDetailInfo.riComm2Gn = riData.riComm2Gn
      this.riDetailInfo.riComm3Gn = riData.riComm3Gn
      if (this.riDetailInfo.propXl === 'P') {
        this.riDetailInfo.propXlDesc = 'Proportional'
      } else {
        this.riDetailInfo.propXlDesc = 'XOL'
      }
      this.riDetailInfo.riComDate = riData.comDateDisp
      this.riDetailInfo.riExpDate = riData.expDateDisp
      this.key = 1
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiDetailLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationRiDetail
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            polNo: this.selectedRi.polNo
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), riData, this.paginationRiDetail.sortBy, this.paginationRiDetail.sortDesc))
          if (result.data) {
            this.totalItemsRiDetail = result.data.totalElements
            const { data } = result.data
            this.riDetailItems = []
            if (data) {
              data.map(riDetail => {
                const convertRiOutHeader = {
                  polNo: this.selectedRi.polNo,
                  renCnt: riDetail.renCnt,
                  cesEndtCnt: riDetail.cesEndtCnt,
                  riType: riDetail.riType,
                  riCo: riDetail.riCo,
                  acctNoSfx: riDetail.acctNoSfx,
                  riskGrpNo: riDetail.riskGrpNo,
                  riskNo: riDetail.riskNo,
                  endtCnt: riDetail.endtCnt,
                  riSIAE: riDetail.riSIAE,
                  riSI: riDetail.riSI,
                  riSIDisp: formatDisplayNumber(riDetail.riSI, 2),
                  riSIPctAE: riDetail.riSIPctAE,
                  riSIPct: riDetail.riSIPct,
                  riSIPctDisp: formatDisplayNumber(riDetail.riSIPct, 6),
                  riPremAE: riDetail.riPremAE,
                  riNetPrem: this.calculateRiNetPrem(riDetail.riPrem, riDetail.riComm1, riDetail.riComm2, riDetail.riComm3),
                  riNetPremDisp: this.calculateRiNetPrem(riDetail.riPrem, riDetail.riComm1, riDetail.riComm2, riDetail.riComm3),
                  riPrem: riDetail.riPrem,
                  riPremDisp: formatDisplayNumber(riDetail.riPrem),
                  riComm1AE: riDetail.riComm1AE,
                  riComm1: riDetail.riComm1,
                  riComm1Disp: formatDisplayNumber(riDetail.riComm1, 2),
                  riComm2AE: riDetail.riComm2AE,
                  riComm2: riDetail.riComm2,
                  riComm2Disp: formatDisplayNumber(riDetail.riComm2, 2),
                  riComm3AE: riDetail.riComm3AE,
                  riComm3: riDetail.riComm3,
                  riComm3Disp: formatDisplayNumber(riDetail.riComm3, 2),
                  prtyLim: riDetail.prtyLim,
                  riLevyAE: riDetail.riLevyAE,
                  riLevy: riDetail.riLevy,
                  riLevyDisp: formatDisplayNumber(riDetail.riLevy, 2),
                  riTaxAE: riDetail.riTaxAE,
                  riTax: riDetail.riTax,
                  riTaxDisp: formatDisplayNumber(riDetail.riTax, 2),
                  riPremAccum: riDetail.riPremAccum,
                  riComm1Accum: riDetail.riComm1Accum,
                  riComm2Accum: riDetail.riComm2Accum,
                  riComm3Accum: riDetail.riComm3Accum,
                  riNetPremAccum: riDetail.riNetPremAccum,
                  riLevyAccum: riDetail.riLevyAccum,
                  riTaxAccum: riDetail.riTaxAccum
                }
                this.riDetailItems.push(convertRiOutHeader)
              })
            } else {
              this.riDetailItems = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      }
      this.fetchRiDetailReload = false
    },
    calculateRiNetPrem(riPrem, riComm1, riComm2, riComm3) {
      return (Number(riPrem) + Number(riComm1) + Number(riComm2) + Number(riComm3))
    },
    async doClearInterFilters() {
      this.filters.inter = ''
      this.filters.name = ''
      this.riCoInit()
    },
    async doInterFilters() {
      this.resetMessages()
      this.paginationRiCo.page = 1
      this.riCoInit()
    },
    async riCoInit() {
      const apiUrl = this.riOutListing.getRiCoLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationRiCo
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.paginationRiCo.sortBy, this.paginationRiCo.sortDesc))
          if (result.data) {
            this.totalItemsRiCo = result.data.totalElements
            const { data } = result.data
            this.riCoItems = []
            if (data) {
              data.map(riCo => {
                const convertRiCo = {
                  inter: riCo.inter,
                  name: riCo.name,
                  interGrp: riCo.interGrp
                }
                this.riCoItems.push(convertRiCo)
              })
            } else {
              this.riCoItems = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('Failed to initialize ri company list. Missing API Url.')
      }
    },
    doProcessCommission(commAE) { // Recalculate Commission if riCompany / Treaty is not blank & Commission checkbox is true
      if (this.riForm.riCo !== undefined && commAE === true) {
        this.processCommission(this.riForm.riCo)
      }
    },
    async processCommission(riCo) {
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.processCommission
      const requestParams = {
        polNo: this.riForm.polNo,
        renCnt: this.riForm.renCnt,
        endtCnt: this.riForm.endtCnt,
        riskGrpNo: this.selectedRi.riskGrpNo,
        riskNo: this.selectedRi.riskNo,
        riCo: riCo,
        riType: this.riForm.riType,
        comm1AE: this.riForm.comm1AE,
        comm1Pct: this.riForm.comm1Pct,
        comm2AE: this.riForm.comm2AE,
        comm2Pct: this.riForm.comm2Pct,
        comm2Gn: this.riForm.comm2Gn,
        comm3AE: this.riForm.comm3AE,
        comm3Pct: this.riForm.comm3Pct,
        comm3Gn: this.riForm.comm3Gn
      }
      if (apiUrl) {
        this.loading = true
        try {
          const result = await this.$http.get(expandURI(apiUrl, requestParams))
          const { data } = result.data
          if (data) {
            this.riForm.comm1Pct = formatDisplayNumber(data.riHeaderDetail.comm1pct, 6)
            this.riForm.comm2Pct = formatDisplayNumber(data.riHeaderDetail.comm2pct, 6)
            this.riForm.comm2Gn = data.riHeaderDetail.comm2gn
            this.riForm.comm3Pct = formatDisplayNumber(data.riHeaderDetail.comm3pct, 6)
            this.riForm.comm3Gn = data.riHeaderDetail.comm3gn
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      }
      this.loading = false
      return true
    },
    async doSelectRiCo(riCo) {
      this.resetValidator()
      this.riForm.addRI = true
      if (this.riForm.riType === 'C' || this.riForm.riType === 'F') {
        this.riForm.riCo = riCo.inter
        this.riForm.riCoDesc = riCo.inter + ' - ' + riCo.name
        this.riForm.riCoWithDesc = riCo.inter + ' - ' + riCo.name
        this.processCommission(riCo.inter)
        this.riCoDialog = false
      }
    },
    async doSelectRiTreaty(riTreaty) {
      this.resetValidator()
      if (this.riForm.riType === 'T' || this.riForm.riType === 'W' || this.riForm.riType === 'D') {
        this.riForm.riCo = riTreaty.ttyNo
        this.riForm.riCoDesc = riTreaty.ttyNo + ' - ' + riTreaty.ttyDesc
        this.riForm.riCoWithDesc = riTreaty.ttyNo + ' - ' + riTreaty.ttyDesc
        this.processCommission(riTreaty.ttyNo).then((result) => {
          if (result) {
            this.changeRiCo()
          }
        })
        this.riTreatyDialog = false
      }
    },
    async doSelectRiAcctNoSfx(riAcctNoSfx) {
      this.resetValidator()
      if (this.riForm.riType === 'C' || this.riForm.riType === 'F') {
        this.riForm.acctNoSfx = riAcctNoSfx.acctNoSfx
        this.riForm.acctNoSfxDesc = riAcctNoSfx.acctNoSfx + ' - ' + riAcctNoSfx.acctNoSfxDesc
        this.riForm.acctNoSfxWithDesc = riAcctNoSfx.acctNoSfx + ' - ' + riAcctNoSfx.acctNoSfxDesc
        this.riAcctNoSfxDialog = false
      }
    },
    async doClearTreatyFilters() {
      this.filters.ttyNo = ''
      this.filters.ttyDesc = ''
      this.riTreatyInit()
    },
    async doTreatyFilters() {
      this.resetMessages()
      this.paginationRiTreaty.page = 1
      this.riTreatyInit()
    },
    async riTreatyInit() {
      const apiUrl = this.riOutListing.getRiTreatyLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationRiTreaty
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          this.filters.ttyType = this.riForm.riType
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.paginationRiTreaty.sortBy, this.paginationRiTreaty.sortDesc))
          if (result.data) {
            this.totalItemsRiTreaty = result.data.totalElements
            const { data } = result.data
            this.riTreatyItems = []
            if (data) {
              data.map(riTreaty => {
                const convertRiTreaty = {
                  ttyNo: riTreaty.ttyNo,
                  ttyDesc: riTreaty.ttyDesc,
                  ttyType: riTreaty.ttyType,
                  ttyYr: riTreaty.ttyYr,
                  effDate: this.formatDate(riTreaty.effDate),
                  expDate: this.formatDate(riTreaty.expDate),
                  comm1AE: riTreaty.comm1ae,
                  comm1Pct: riTreaty.comm1pct,
                  comm2AE: riTreaty.comm2ae,
                  comm2Pct: riTreaty.comm2pct,
                  comm2Gn: riTreaty.comm2gn,
                  comm3AE: riTreaty.comm3ae,
                  comm3Pct: riTreaty.comm3pct,
                  comm3Gn: riTreaty.comm3gn
                }
                this.riTreatyItems.push(convertRiTreaty)
              })
            } else {
              this.riTreatyItems = []
            }
            this.loading = false
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.$toast.error('Failed to initialize treaty list. Missing API Url.')
      }
    },
    async riAcctNoSfxInit(acctNoSfxApplnInt) {
      const apiUrl = this.riOutListing.getAcctNoSfxLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationRiAcctNoSfx
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            acctNoSfxApplnInt: acctNoSfxApplnInt,
            polNo: this.selectedRi.polNo
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.paginationRiAcctNoSfx.sortBy, this.paginationRiAcctNoSfx.sortDesc))
          if (result.data) {
            this.totalItemsRiAcctNoSfx = result.data.totalElements
            const { data } = result.data
            this.riAcctNoSfxItems = []
            if (data) {
              data.map(riAcctNoSfx => {
                const convertRiAcctNoSfx = {
                  acctNoSfx: riAcctNoSfx.acctNoSfx,
                  acctNoSfxDesc: riAcctNoSfx.applnIntDesc
                }
                this.riAcctNoSfxItems.push(convertRiAcctNoSfx)
              })
              this.loading = false
              return true
            } else {
              this.riAcctNoSfxItems = []
              this.loading = false
              return false
            }
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      } else {
        this.$toast.error('Failed to initialize acctNoSfx list. Missing API Url.')
      }
    },
    async acctNoSfxInit(acctNoSfxApplnInt, dri) {
      const apiUrl = this.riOutListing.getAcctNoSfxByIdLists
      if (apiUrl) {
        try {
          const expand = {
            acctNoSfxApplnInt: acctNoSfxApplnInt,
            dri: dri
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result.data) {
            const { data } = result.data
            this.riAcctNoSfxListItems = []
            if (data) {
              data.acctNoSfxMapList.map(c =>
                this.riAcctNoSfxListItems.push(c)
              )
              return true
            } else {
              this.riAcctNoSfxListItems = []
              return false
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          return false
        }
      } else {
        this.$toast.error('Failed to initialize acctNoSfx list. Missing API Url.')
      }
    },
    async doFetchRiOutBordList(riDetailData) {
      const apiUrl = this.riOutListing.getRiOutBordLists
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationRiOutBord
          const expand = {
            page: page - 1,
            size: itemsPerPage
          }
          const filterData = {
            polNo: riDetailData.polNo,
            renCnt: riDetailData.renCnt,
            cesEndtCnt: riDetailData.cesEndtCnt,
            riType: riDetailData.riType,
            riCo: riDetailData.riCo,
            acctNoSfx: riDetailData.acctNoSfx,
            riskGrpNo: riDetailData.riskGrpNo,
            riskNo: riDetailData.riskNo
          }
          // let filterData = clone(riDetailData)
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), filterData, this.paginationRiOutBord.sortBy, this.paginationRiOutBord.sortDesc))
          if (result.data) {
            this.totalItemsRiOutBord = result.data.totalElements
            const { data } = result.data
            this.riOutBordItems = []
            if (data) {
              data.map(riOutBord => {
                const convertRiOutBord = {
                  polNo: riOutBord.polNo,
                  renCnt: riOutBord.renCnt,
                  cesEndtCnt: riOutBord.cesEndtCnt,
                  riType: riOutBord.riType,
                  riCo: riOutBord.riCo,
                  acctNoSfx: riOutBord.acctNoSfx,
                  riskGrpNo: riOutBord.riskGrpNo,
                  riskNo: riOutBord.riskNo,
                  itemNo: riOutBord.itemNo,
                  cedPolNo: riOutBord.cedPolNo,
                  riSIAE: riOutBord.riSIAE,
                  riSI: formatPrice(riOutBord.riSI),
                  riSIPct: riOutBord.riSIPct.toFixed(6),
                  riPremAE: riOutBord.riPremAE,
                  riPrem: formatPrice(riOutBord.riPrem),
                  riComm1AE: riOutBord.riComm1AE,
                  riComm1: formatPrice(riOutBord.riComm1),
                  riComm2AE: riOutBord.riComm2AE,
                  riComm2: formatPrice(riOutBord.riComm2),
                  riComm3AE: riOutBord.riComm3AE,
                  riComm3: formatPrice(riOutBord.riComm3)
                }
                this.riOutBordItems.push(convertRiOutBord)
              })
              this.loading = false
              return this.riOutBordItems
            } else {
              this.loading = false
              this.riOutBordItems = []
              return false
            }
          }
        } catch (err) {
          const { data } = err.response.data
          if (data) {
            this.message(data)
          }
          return false
        }
      } else {
        this.$toast.error('Failed to initialize riOutBord list. Missing API Url.')
        return false
      }
    },
    async doFetchRiOutBord(riData) {
      if (this.newRiOutBord === false) {
        const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiOutBordDetail
        const requestParams = {
          polNo: riData.polNo,
          renCnt: riData.renCnt,
          cesEndtCnt: riData.cesEndtCnt,
          riType: riData.riType,
          riCo: riData.riCo,
          acctNoSfx: riData.acctNoSfx,
          riskGrpNo: riData.riskGrpNo,
          riskNo: riData.riskNo,
          itemNo: riData.itemNo
        }
        if (apiUrl) {
          this.loading = true
          try {
            const result = await this.$http.get(expandURI(apiUrl, requestParams))
            const { data } = result.data
            if (data && data.riOutBordDetail) {
              this.riForm.riTypeCo = data.riOutBordDetail.riType + ' / ' + data.riOutBordDetail.riCo + ' - ' + data.inter
              this.riForm.cedPolNo = data.riOutBordDetail.cedPolNo
              this.riForm.itemNo = data.riOutBordDetail.itemNo
              this.riForm.riSIAE = data.riOutBordDetail.riSIAE
              this.riForm.riSI = formatPrice(data.riOutBordDetail.riSI)
              this.riForm.riSIPct = data.riOutBordDetail.riSIPct.toFixed(6)
              this.riForm.riPremAE = data.riOutBordDetail.riPremAE
              this.riForm.riPrem = formatPrice(data.riOutBordDetail.riPrem)
              this.riForm.riComm1AE = data.riOutBordDetail.riComm1AE
              this.riForm.riComm1 = formatPrice(data.riOutBordDetail.riComm1)
              this.riForm.riComm2AE = data.riOutBordDetail.riComm2AE
              this.riForm.riComm2 = formatPrice(data.riOutBordDetail.riComm2)
              this.riForm.riComm3AE = data.riOutBordDetail.riComm3AE
              this.riForm.riComm3 = formatPrice(data.riOutBordDetail.riComm3)
            }
            this.loading = false
          } catch (err) {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          }
        }
      }
    },
    async doFetchRiOutBordItem(riData) {
      if (this.newRiOutBord) {
        const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getRiOutBordItem
        const requestParams = {
          polNo: riData.polNo,
          renCnt: riData.renCnt,
          endtCnt: riData.endtCnt
        }
        if (apiUrl) {
          this.loading = true
          try {
            const result = await this.$http.get(expandURI(apiUrl, requestParams))
            if (result && result.data && result.data.data) {
              this.bordItemList = result.data.data
            }
            this.loading = false
          } catch (err) {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          }
        }
      }
    },
    async createRiOutBord() {
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.createRiOutBord
      if (apiURI) {
        try {
          const expand = {
            polNo: this.riForm.polNo,
            renCnt: this.riForm.renCnt,
            endtCnt: this.riForm.endtCnt,
            cesEndtCnt: this.riForm.cesEndtCnt,
            riType: this.riForm.riType,
            riCo: this.riForm.riCo,
            acctNoSfx: this.riForm.acctNoSfx,
            riskGrpNo: this.riDetailForm.riskGrpNo === undefined
              ? this.riForm.riskGrpNo : this.riDetailForm.riskGrpNo,
            riskNo: this.riDetailForm.riskNo === undefined
              ? this.riForm.riskNo : this.riDetailForm.riskNo
          }
          const result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            this.notify(data)
            return data
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          return false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    async updateRiOutBord() {
      var success = false
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.updateRiOutBord
      if (apiURI) {
        try {
          this.riForm.riskGrpNo = this.riDetailForm.riskGrpNo
          this.riForm.riskNo = this.riDetailForm.riskNo
          this.riForm.riSI = removeFormatNumber(this.riForm.riSI)
          this.riForm.riSIPct = removeFormatNumber(this.riForm.riSIPct)
          this.riForm.riPrem = removeFormatNumber(this.riForm.riPrem)
          this.riForm.riComm1 = removeFormatNumber(this.riForm.riComm1)
          this.riForm.riComm2 = removeFormatNumber(this.riForm.riComm2)
          this.riForm.riComm3 = removeFormatNumber(this.riForm.riComm3)
          const result = await this.$http.post(apiURI, this.riForm)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          success = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
      return success
    },
    async recalculate() {
      await this.checkCoInsQS()

      if (this.riDetailForm.riSIPctAE) {
        this.riDetailForm.riSIPct = this.checkCoInsQSData.riPct
      }
      this.riDetailForm.riSIPct = Number(this.riDetailForm.riSIPct).toFixed(6)

      const riSIPct = Number(removeFormatNumber(this.riDetailForm.riSIPct))
      const notWriSIPct = Number(removeFormatNumber(this.checkCoInsQSData.notWriSIPct))
      const riPremAccum = Number(removeFormatNumber(this.riDetailForm.riPremAccum))
      const si = Number(removeFormatNumber(this.polRisk.si))
      const coInsPct = Number(removeFormatNumber(this.checkCoInsQSData.coInsPct))
      const comm1Pct = Number(removeFormatNumber(this.riOutMaster.comm1Pct))
      const comm2Pct = Number(removeFormatNumber(this.riOutMaster.comm2Pct))
      const comm3Pct = Number(removeFormatNumber(this.riOutMaster.comm3Pct))

      if (this.riDetailForm.riSIAE) {
        if (this.riDetailForm.riType === 'W') {
          if (this.checkCoInsQSData.coInsExist) {
            this.riDetailForm.riSI = formatDisplayNumber(formatPrice((si * notWriSIPct / 100 * riSIPct / 100 * coInsPct / 100).toFixed(2)), 2)
          } else {
            this.riDetailForm.riSI = formatDisplayNumber(formatPrice(((si * notWriSIPct / 100 * riSIPct / 100)).toFixed(2)), 2)
          }
        } else if (this.riDetailForm.riType === 'C') {
          this.riDetailForm.riSI = formatDisplayNumber(formatPrice((si * riSIPct / 100).toFixed(2)), 2)
        } else {
          if (this.checkCoInsQSData.coInsExist) {
            this.riDetailForm.riSI = formatDisplayNumber(formatPrice(((si * coInsPct / 100) * riSIPct / 100).toFixed(2)), 2)
          } else {
            this.riDetailForm.riSI = formatDisplayNumber(formatPrice((si * riSIPct / 100).toFixed(2)), 2)
          }
        }
      }
      if (this.riDetailForm.riPremAE) {
        if (this.riDetailForm.riType === 'W') {
          if (this.riDetailForm.cesEndtCnt > 0) {
            this.riDetailForm.riPrem = formatDisplayNumber(formatPrice((((this.reCalcRIPrem() * (notWriSIPct / 100) * riSIPct / 100) + riPremAccum) * -1).toFixed(2)), 2)
          } else {
            this.riDetailForm.riPrem = formatDisplayNumber(formatPrice(((this.reCalcRIPrem() * (notWriSIPct / 100) * riSIPct / 100) * -1).toFixed(2)), 2)
          }
        } else if (this.riDetailForm.riType === 'C') {
          if (this.riDetailForm.cesEndtCnt > 0) {
            this.riDetailForm.riPrem = formatDisplayNumber(formatPrice((((this.reCalcRIPrem() * riSIPct / 100) + riPremAccum) * -1).toFixed(2)), 2)
          } else {
            this.riDetailForm.riPrem = formatDisplayNumber(formatPrice(((this.reCalcRIPrem() * riSIPct / 100) * -1).toFixed(2)), 2)
          }
        } else {
          if (this.riDetailForm.cesEndtCnt > 0) {
            this.riDetailForm.riPrem = formatDisplayNumber(formatPrice((((this.reCalcRIPrem() * riSIPct / 100) + riPremAccum) * -1).toFixed(2)), 2)
          } else {
            this.riDetailForm.riPrem = formatDisplayNumber(formatPrice(((this.reCalcRIPrem() * riSIPct / 100) * -1).toFixed(2)), 2)
          }
        }
        const riPrem = Number(removeFormatNumber(this.riDetailForm.riPrem))
        if (this.riDetailForm.riComm1AE) {
          this.riDetailForm.riComm1 = formatDisplayNumber(formatPrice((riPrem * -1 * comm1Pct / 100).toFixed(2)), 2)
        }
        if (this.riDetailForm.riComm2AE) {
          const riComm1 = Number(removeFormatNumber(this.riDetailForm.riComm1))
          // Check is Gross or Net
          if (this.checkCoInsQSData.comm2Gn === 'G') {
            this.riDetailForm.riComm2 = formatDisplayNumber(formatPrice((riPrem * -1 * comm2Pct / 100).toFixed(2)), 2)
          } else if (this.checkCoInsQSData.comm2Gn === 'N') {
            this.riDetailForm.riComm2 = formatDisplayNumber(formatPrice((((riPrem * -1) - riComm1) * comm2Pct / 100).toFixed(2)), 2)
          }
        }
        if (this.riDetailForm.riComm3AE) {
          const riComm1 = Number(removeFormatNumber(this.riDetailForm.riComm1))
          const riComm2 = Number(removeFormatNumber(this.riDetailForm.riComm2))
          // Check is Gross or Net
          if (this.checkCoInsQSData.comm3Gn === 'G') {
            this.riDetailForm.riComm3 = formatDisplayNumber(formatPrice((riPrem * -1 * comm3Pct / 100).toFixed(2)), 2)
          } else if (this.checkCoInsQSData.comm3Gn === 'N') {
            this.riDetailForm.riComm3 = formatDisplayNumber(formatPrice((((riPrem * -1) - riComm1 - riComm2) * comm3Pct / 100).toFixed(2)), 2)
          }
        }
      } else {
        const riPrem = Number(removeFormatNumber(this.riDetailForm.riPrem))

        if (this.riDetailForm.riComm1AE) {
          this.riDetailForm.riComm1 = formatDisplayNumber(formatPrice((riPrem * -1 * comm1Pct / 100).toFixed(2)), 2)
        }
        if (this.riDetailForm.riComm2AE) {
          const riComm1 = Number(removeFormatNumber(this.riDetailForm.riComm1))
          // Check is Gross or Net
          if (this.checkCoInsQSData.comm2Gn === 'G') {
            this.riDetailForm.riComm2 = formatDisplayNumber(formatPrice((riPrem * -1 * comm2Pct / 100).toFixed(2)), 2)
          } else if (this.checkCoInsQSData.comm2Gn === 'N') {
            this.riDetailForm.riComm2 = formatDisplayNumber(formatPrice(((riPrem * -1 - riComm1) * comm2Pct / 100).toFixed(2)), 2)
          }
        }
        if (this.riDetailForm.riComm3AE) {
          const riComm1 = Number(removeFormatNumber(this.riDetailForm.riComm1))
          const riComm2 = Number(removeFormatNumber(this.riDetailForm.riComm2))
          // Check is Gross or Net
          if (this.checkCoInsQSData.comm3Gn === 'G') {
            this.riDetailForm.riComm3 = formatDisplayNumber(formatPrice((riPrem * -1 * comm3Pct / 100).toFixed(2)), 2)
          } else if (this.checkCoInsQSData.comm3Gn === 'N') {
            this.riDetailForm.riComm3 = formatDisplayNumber(formatPrice(((riPrem * -1 - riComm1 - riComm2) * comm3Pct / 100).toFixed(2)), 2)
          }
        }
      }
    },
    reCalcRIPrem() {
      if (!this.miscparams) return 0
      const premDue = Number(removeFormatNumber(this.polRisk.premDueDiscLdg))
      const disc = Number(removeFormatNumber(this.checkCoInsQSData.disc))
      if (this.miscparams.dtChgRIDiscImpl) {
        const tranDate = formatServerTimeFormat(this.riForm.tranDate)
        const dtChgRIDiscImpl = formatServerTimeFormat(this.miscparams.dtChgRIDiscImpl)
        if (tranDate >= dtChgRIDiscImpl) {
          return this.miscparams.riDisc ? premDue : (premDue + disc)
        } else if (tranDate < dtChgRIDiscImpl) {
          return this.miscparams.riDisc ? (premDue + disc) : premDue
        }
      } else {
        return this.miscparams.riDisc ? premDue : (premDue + disc)
      }
    },
    recalculateRIOutBord() {
      const riSI = Number(removeFormatNumber(this.riForm.riSI))
      const riSIPct = Number(removeFormatNumber(this.riForm.riSIPct))

      if (this.riForm.riPremAE) {
        this.disableRiPrem = true
        this.riForm.riPrem = formatDisplayNumber(formatPrice((riSI * riSIPct / 100).toFixed(2)), 2)
      } else {
        this.disableRiPrem = false
      }
      const riPrem = Number(removeFormatNumber(this.riForm.riPrem))
      if (this.riForm.riComm1AE) {
        const comm1Pct = Number(removeFormatNumber(this.riForm.comm1Pct))
        this.riForm.riComm1 = formatDisplayNumber(formatPrice((riPrem * -1 * comm1Pct / 100).toFixed(2)), 2)
        this.disableRiComm1 = true
      } else {
        this.disableRiComm1 = false
      }
      if (this.riForm.riComm2AE) {
        this.disableRiComm2 = true
        const comm2Pct = Number(removeFormatNumber(this.riForm.comm2Pct))
        const riComm1 = Number(removeFormatNumber(this.riForm.riComm1))
        // Check is Gross or Net
        if (this.riForm.comm2Gn === 'G') {
          this.riForm.riComm2 = formatDisplayNumber(formatPrice((riPrem * -1 * comm2Pct / 100).toFixed(2)), 2)
        } else if (this.riForm.comm2Gn === 'N') {
          this.riForm.riComm2 = formatDisplayNumber(formatPrice(((riPrem * -1 - riComm1) * comm2Pct / 100).toFixed(2)), 2)
        }
      } else {
        this.disableRiComm2 = false
      }
      if (this.riForm.riComm3AE) {
        this.disableRiComm3 = true
        const comm3Pct = Number(removeFormatNumber(this.riForm.comm3Pct))
        const riComm1 = Number(removeFormatNumber(this.riForm.riComm1))
        const riComm2 = Number(removeFormatNumber(this.riForm.riComm2))
        // Check is Gross or Net
        if (this.riForm.comm3Gn === 'G') {
          this.riForm.riComm3 = formatDisplayNumber(formatPrice((riPrem * -1 * comm3Pct / 100).toFixed(2)), 2)
        } else if (this.riForm.comm3Gn === 'N') {
          this.riForm.riComm3 = formatDisplayNumber(formatPrice(((riPrem * -1 - riComm1 - riComm2) * comm3Pct / 100).toFixed(2)), 2)
        }
      } else {
        this.disableRiComm3 = false
      }
    },
    convertDecimal(comm) {
      var Comm = comm.toFixed(2)
      return Comm
    },
    formatDisplayNumber(xNum, scale) {
      return formatDisplayNumber(xNum, scale)
    },
    removeFormatNumber(value) {
      return removeFormatNumber(value)
    },
    async createRiOutAmdt() {
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.createRiOutAmdt
      if (apiURI) {
        this.processingFlag = true
        try {
          const expand = {
            polNo: this.selectedRi.polNo,
            renCnt: this.selectedRi.renCnt,
            cesEndtCnt: this.selectedRi.cesEndtCnt,
            riType: this.selectedRi.riType,
            riCo: this.selectedRi.riCo,
            acctNoSfx: this.selectedRi.acctNoSfx,
            endtCnt: this.selectedRi.endtCnt,
            verCnt: this.riForm.verCnt,
            ccaDate: this.riForm.ccaDate,
            ccdDate: this.riForm.ccdDate,
            theirPolNo: this.riForm.theirPolNo
          }
          const result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.processingFlag = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async onChangeRiCo() {
      this.riForm.polNo = this.polMaster.polNo
      this.riForm.renCnt = this.polMaster.renCnt
      this.riForm.endtCnt = this.polMaster.endtCnt
      this.riForm.addRI = (this.newRiHeader === true && this.riForm.selectedComm === '')
      if (this.riForm.riType === 'T' || this.riForm.riType === 'W' || this.riForm.riType === 'C' || this.riForm.riType === 'F') {
        await this.processCommission(this.riForm.riCo)
      }
    },
    async changeRiCo() {
      if (this.selectedRi !== undefined) {
        this.riForm.polNo = this.selectedRi.polNo
        this.riForm.renCnt = this.selectedRi.renCnt
        this.riForm.endtCnt = this.selectedRi.endtCnt
      } else if (this.polMaster !== undefined) {
        this.riForm.polNo = this.polMaster.polNo
        this.riForm.renCnt = this.polMaster.renCnt
        this.riForm.endtCnt = this.polMaster.endtCnt
      }
      this.riForm.addRI = (this.newRiHeader === true && this.riForm.selectedComm === '')
      if (this.riForm.riType === 'T' || this.riForm.riType === 'W' || this.riForm.riType === 'C' || this.riForm.riType === 'F') {
        if (this.riForm.riCoDesc !== undefined && this.riForm.riCoDesc !== '') {
          await this.processCommission(this.riForm.riCo)
        }
      } else if (this.riForm.riType === 'D') {
        await this.processCommission(this.riForm.riCo)
      }
    },
    removeFormatDate(date) {
      if (date === null) {
        return null
      } else if (date === undefined) {
        return null
      } else if (date === '') {
        return null
      } else {
        var dateString = date
        var dateParts = dateString.split('/')
        return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
      }
    },
    async checkTranDate(tranDate) {
      this.resetMessages()
      this.riForm.tranDateValidationMessage = undefined
      this.riForm.tranDateValidation = false
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.valDateWithinRange
      if (apiURI) {
        try {
          if (this.riForm.tranDate) {
            const requestParams = {
              tranDate: this.removeFormatDate(this.formatDate(this.riForm.tranDate)),
              polNo: this.selectedRi.polNo,
              renCnt: this.selectedRi.renCnt,
              endtCnt: this.selectedRi.endtCnt
            }
            const result = await this.$http.get(expandURI(apiURI, requestParams))
            const data = result.data.data
            if (data) {
              const date = new Date(this.riForm.tranDate)
              this.riForm.cesYr = data.polType === false ? date.getFullYear() : data.acctPeriod.acctPerYr
              this.riForm.acctMth = data.acctPeriod.acctPerMth
              this.riForm.acctYr = data.acctPeriod.acctPerYr
              return true
            } else {
              return false
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            if (data.messages) {
              this.riForm.tranDateValidationMessage = data.messages[0].message
              this.riForm.tranDateValidation = true
            }
            this.message(data)
            this.promptFieldCheck()
            return false
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async checkTranDate2(tranDate) {
      this.resetMessages()
      this.riForm.tranDateValidationMessage = undefined
      this.riForm.tranDateValidation = false
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.valDateWithinRangeByPRE
      if (apiURI) {
        try {
          if (this.riForm.tranDate) {
            const requestParams = {
              tranDate: this.removeFormatDate(this.formatDate(this.riForm.tranDate)),
              polNo: this.selectedRi.polNo,
              renCnt: this.selectedRi.renCnt,
              endtCnt: this.selectedRi.endtCnt,
              riType: this.selectedRi.riType,
              riCo: this.selectedRi.riCo
            }
            const result = await this.$http.get(expandURI(apiURI, requestParams))
            const { data } = result.data
            if (data) {
              this.riForm.cesYr = data.polType === false ? this.riForm.tranDate.getFullYear() : data.acctPeriod.acctPerYr
              this.riForm.acctMth = data.acctPeriod.acctPerMth
              this.riForm.acctYr = data.acctPeriod.acctPerYr
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            if (data.messages) {
              if (data.resultMap.riType === this.selectedRi.riType && data.resultMap.riCo === this.selectedRi.riCo) {
                this.riForm.tranDateValidationMessage = data.messages[0].message
                this.riForm.tranDateValidation = true
              } else {
                this.riForm.tranDateValidation = false
              }
            }
            this.message(data)
            this.promptFieldCheck()
            return this.riForm.tranDateValidation
          }
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    checkRIComm1AE() {
      this.riForm.addRI = false
      this.riForm.selectedComm = 'comm1AE'
      if (this.riForm.riType !== undefined && this.riForm.riType !== '') {
        if (this.riForm.comm1AE) {
          this.changeRiCo()
        }
      }
    },
    checkRIComm2AE(newRiHeader) {
      this.riForm.selectedComm = 'comm2AE'
      if (this.riForm.riType !== undefined && this.riForm.riType !== '') {
        if (this.riForm.riType === 'D') {
          if (this.riForm.comm2AE) {
            this.changeRiCo(this.riForm.riCo)
          }
        } else if (this.riForm.riType === 'F' || this.riForm.riType === 'C') {
          if (this.riForm.comm2AE) {
            this.changeRiCo()
          }
        } else if (this.riForm.riType === 'T' || this.riForm.riType === 'W') {
          if ((this.riForm.riType === 'T' || this.riForm.riType === 'W') && this.riForm.riCo !== undefined && this.riForm.riCo !== '') {
            if (this.riForm.comm2AE) {
              this.changeRiCo(this.riForm.riCo)
            }
          }
        }
      }
      if (newRiHeader) {
      } else {}
    },
    checkRIComm3AE(newRiHeader) {
      this.riForm.selectedComm = 'comm3AE'
      if (this.riForm.riType !== undefined && this.riForm.riType !== '') {
        if (this.riForm.comm3AE) {
          if (this.riForm.riType === 'T') {
            this.changeRiCo(this.riForm.riCo)
          } else if (this.riForm.riType === 'D' || this.riForm.riType === 'C' || this.riForm.riType === 'F') {
            this.riForm.comm3Pct = formatDisplayNumber(0, 6)
          }
        }
      }
      if (newRiHeader) {
      }
    },
    async checkPolBordItem(selectedRi) {
      if (this.newRiHeader === false) {
        const apiUrl = this.$store.state.reinsurance.riOutListing.menu.getPolBordItem
        const requestParams = {
          polNo: selectedRi.polNo,
          renCnt: selectedRi.renCnt,
          endtCnt: selectedRi.endtCnt
        }
        if (apiUrl) {
          this.loading = true
          try {
            const result = await this.$http.get(expandURI(apiUrl, requestParams))
            const { data } = result.data
            if (data) {
              this.selectedRi.riskGrpNo = data.riskGrpNo
            }
            this.loading = false
          } catch (err) {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          }
        }
      }
    },
    doRiTreatyFilters() {
      this.resetMessages()
      this.paginationRiTreaty.page = 1
      this.riTreatyInit()
    },
    doClearRiTreatyFilters() {
      this.filters.ttyNo = undefined
      this.filters.ttyDesc = undefined
      this.riTreatyInit()
    },
    doAcctNoSfxFilters() {
      this.resetMessages()
      this.paginationRiAcctNoSfx.page = 1
      if (this.riForm.riType === 'C') {
        this.riAcctNoSfxInit(6)
      } else if (this.riForm.riType === 'F') {
        this.riAcctNoSfxInit(5)
      }
    },
    doClearAcctNoSfxFilters() {
      this.filters.acctNoSfx = undefined
      if (this.riForm.riType === 'C') {
        this.riAcctNoSfxInit(6)
      } else if (this.riForm.riType === 'F') {
        this.riAcctNoSfxInit(5)
      }
    },
    async recalculateRiskPremW() {
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.calcRIValueW
      if (apiUrl) {
        try {
          let clone1 = clone(this.riDetailForm)
          clone1.riSI = removeFormatNumber(clone1.riSI)
          clone1.riComm1 = removeFormatNumber(clone1.riComm1)
          clone1.riComm2 = removeFormatNumber(clone1.riComm2)
          clone1.riComm3 = removeFormatNumber(clone1.riComm3)
          clone1.riPrem = removeFormatNumber(clone1.riPrem)
          const result = await this.$http.post(apiUrl, clone1)
          const { data } = result.data
          if (data) {
            if (this.riDetailForm.riPremAE) {
              this.riDetailForm.riPrem = formatDisplayNumber(data.riDetailDetail.riPrem, 2)
            }
            if (this.riDetailForm.riSIAE) {
              this.riDetailForm.riSI = formatDisplayNumber(data.riDetailDetail.riSI, 2)
            }
            if (this.riDetailForm.riComm1AE) {
              this.riDetailForm.riComm1 = formatDisplayNumber(data.riDetailDetail.riComm1, 2)
            }
            if (this.riDetailForm.riComm2AE) {
              this.riDetailForm.riComm2 = formatDisplayNumber(data.riDetailDetail.riComm2, 2)
            }
            if (this.riDetailForm.riComm3AE) {
              this.riDetailForm.riComm3 = formatDisplayNumber(data.riDetailDetail.riComm3, 2)
            }
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async checkCoInsQS() {
      const apiUrl = this.$store.state.reinsurance.riOutListing.menu.checkCoInsQS
      if (apiUrl) {
        try {
          let clone1 = clone(this.riDetailForm)
          clone1.riSI = removeFormatNumber(clone1.riSI)
          clone1.riPrem = removeFormatNumber(clone1.riPrem)
          clone1.riComm1 = removeFormatNumber(clone1.riComm1)
          clone1.riComm2 = removeFormatNumber(clone1.riComm2)
          clone1.riComm3 = removeFormatNumber(clone1.riComm3)
          clone1.riLevy = removeFormatNumber(clone1.riLevy)
          clone1.riTax = removeFormatNumber(clone1.riTax)
          clone1.riskGrpNo = this.selectedRi.riskGrpNo
          clone1.riskNo = this.selectedRi.riskNo
          const result = await this.$http.post(apiUrl, clone1)
          const { data } = result.data
          if (data) {
            this.checkCoInsQSData.coInsExist = data.coInsQSDto.coInsExist
            this.checkCoInsQSData.coInsPct = data.coInsQSDto.coInsPct
            this.checkCoInsQSData.notWriSIPct = data.coInsQSDto.notWriSIPct
            this.checkCoInsQSData.comm2Gn = data.coInsQSDto.comm2GN
            this.checkCoInsQSData.comm3Gn = data.coInsQSDto.comm3GN
            this.checkCoInsQSData.riPct = data.coInsQSDto.riPct.toFixed(6)
            this.checkCoInsQSData.disc = data.coInsQSDto.disc
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async processRiAutoCession() {
      const apiURI = this.$store.state.reinsurance.riOutListing.menu.processRiAutoCession
      if (apiURI) {
        this.processingFlag = true
        try {
          const expand = {
            polNo: this.selectedRi.polNo,
            renCnt: this.selectedRi.renCnt,
            endtCnt: this.selectedRi.endtCnt,
            riskGrpNo: this.selectedRi.riskGrpNo,
            riskNo: this.selectedRi.riskNo
          }
          const result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.processingFlag = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.processingFlag = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  mixins: [
    MessageMixin
  ]
}
